import styled from 'styled-components';
import { animated } from 'react-spring';

const Inner = styled(animated.div)`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.splashSun};
  border-radius: 50%;
`;

export default Inner;
